import { z } from 'zod';

export const feedbackSchema = z.object({
  feedback: z.string().optional(),
  score: z.number({ required_error: 'Score is required' }).min(0).max(1),
});

export type FeedbackSchema = z.infer<typeof feedbackSchema>;
